import { render } from "./ProposalList.vue?vue&type=template&id=31432ed9&scoped=true&ts=true"
import script from "./ProposalList.vue?vue&type=script&lang=ts"
export * from "./ProposalList.vue?vue&type=script&lang=ts"

import "./ProposalList.vue?vue&type=style&index=0&id=31432ed9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31432ed9"]])

export default __exports__